// Feature represents a feature that can be limited by subscription plan.
export type Feature =
  | "geofences"
  | "sensors"
  | "sensor_groups"
  | "flight_plans"
  | "email_notifications";

export const AllFeatures: Feature[] = [
  "geofences",
  "sensors",
  "sensor_groups",
  "flight_plans",
  "email_notifications",
];

export interface PlanLimits {
  MaxGeofences: number;
  MaxSensors: number;
  MaxSensorGroups: number;
  MaxFlightPlans: number;
  EmailNotifications: boolean;
}

// Plan definitions matching the backend
export const PlanDefinitions: Record<string, PlanLimits> = {
  free: {
    MaxGeofences: 0,
    MaxSensors: 1,
    MaxSensorGroups: 1,
    MaxFlightPlans: 5,
    EmailNotifications: false,
  },
  pro: {
    MaxGeofences: -1,
    MaxSensors: -1,
    MaxSensorGroups: -1,
    MaxFlightPlans: -1,
    EmailNotifications: true,
  },
};

export const DefaultPlanSlug = "free";

export function getPlanLimits(planSlug: string | null | undefined): PlanLimits {
  if (!planSlug) {
    return PlanDefinitions[DefaultPlanSlug];
  }
  const normalizedSlug = planSlug.toLowerCase();
  if (normalizedSlug in PlanDefinitions) {
    return PlanDefinitions[normalizedSlug];
  }
  return PlanDefinitions[DefaultPlanSlug];
}

export function isUnlimited(limit: number): boolean {
  return limit < 0;
}

export function getLimit(limits: PlanLimits, feature: Feature): number {
  switch (feature) {
    case "geofences":
      return limits.MaxGeofences;
    case "sensors":
      return limits.MaxSensors;
    case "sensor_groups":
      return limits.MaxSensorGroups;
    case "flight_plans":
      return limits.MaxFlightPlans;
    case "email_notifications":
      return limits.EmailNotifications ? 1 : 0;
    default:
      return 0;
  }
}

export function hasFeatureAccess(
  limits: PlanLimits,
  feature: Feature,
  currentCount?: number
): boolean {
  const limit = getLimit(limits, feature);
  
  if (isUnlimited(limit)) {
    return true;
  }
  
  if (currentCount === undefined) {
    // If we don't know the current count, check if the limit allows any
    return limit > 0;
  }
  
  return currentCount < limit;
}
